



























import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { MyClientRect } from './types';
import { domService } from '../dom-service';
import SwNav from './sw-nav.vue';
import { CSSStyleOptions } from '../common-types';

/**
 * This indicator could be use for both left hand nav and top nav.
 */
@Component({
})
export default class SwNavSideIndicator extends SwExtendedVue {
  cssPrefix: string = 'sw-nav-side-indicator';

  @Prop({ type: String, required: true })
  color: string;

  @Prop({ type: Object })
  referrerRect: MyClientRect;

  @Prop({ type: String, default: 'vertical' })
  direction: 'vertical' | 'horizontal';

  get offset(): number {
    if (!this.referrerRect) { return 0; }
    const el = this.$el as HTMLElement;
    if (!el || !el.offsetParent) { return 0; }
    const parentRect = el.offsetParent.getBoundingClientRect();
    if (this.direction === 'vertical') {
      return this.referrerRect.top - parentRect.top + (this.referrerRect.height / 2) - (el.offsetHeight / 2);
    }
    return this.referrerRect.left - parentRect.left + (this.referrerRect.width / 2) - (el.offsetWidth / 2);
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {
      backgroundColor: this.color,
    };
    if (this.direction === 'vertical') {
      style.top = `${this.offset}px`;
    } else {
      style.left = `${this.offset}px`;
    }
    return style;
  }

  @Inject()
  private claimCheckHighlightReferrerRequest: SwNav['claimCheckHighlightReferrerRequest'];

  private onVisibilityChange(visible: boolean) {
    if (!visible) { return; }
    this.claimCheckHighlightReferrerRequest();
  }

  private mounted() {
    domService.visibilityObserver.on(this.$el as HTMLElement, this.onVisibilityChange);
  }

  private beforeDestroy() {
    domService.visibilityObserver.off(this.$el as HTMLElement);
  }
}
